export const buildFilterSection = (appliedFilters, config) =>
    config
    .filter((item) =>appliedFilters.some((filter) => filter.column === item.column))
    .map((item) => {
        const applied = appliedFilters.find((filter) => filter.column === item.column);

        return {
            ...item,
            options: item.options.filter((option) => {
                if (Array.isArray(applied.filterValue)) 
                {
                    return applied.filterValue.some((value) => {
                        if (Array.isArray(option.value)) {
                            return (
                                option.value.length === value.length &&
                                option.value.every((v, i) => v === value[i])
                            );
                        }
                        return option.value === value;
                    });
                }

                if (Array.isArray(option.value)) {
                    return (
                        option.value.length === applied.filterValue.length &&
                        option.value.every(
                        (v, i) => v === applied.filterValue[i],
                        )
                    );
                }
                
                return option.value === applied.filterValue;
            }),
        };
    });